import { Component, OnInit, Input } from '@angular/core';
import { AdminQuestion, QuestionType, Answer } from '../../../models/questions';
import { AnswerCategoryType } from '../../../models/questions/answer-category-type.enum';

@Component({
  selector: 'app-question-checkbox-radio',
  templateUrl: './question-checkbox-radio.component.html',
  styleUrls: ['./question-checkbox-radio.component.scss']
})
export class QuestionCheckboxRadioComponent implements OnInit {
  @Input() question: AdminQuestion = {};
  answerCategoryType = AnswerCategoryType;

  ngOnInit() {
    this.sortAnswersByOrder(this.question.answers);
  }

  getIsCheckbox(): boolean {
    return this.question.answerType === QuestionType.Checkbox;
  }

  getIsRating(): boolean {
    return this.question.answerType === QuestionType.Rating;
  }

  getIsSatisfactionRate(): boolean {
    return this.question.answerType === QuestionType.SatisfactionRate;
  }

  private sortAnswersByOrder(answers: Array<Answer>) {
    return answers.sort((a, b) => a.order - b.order);
  }
}
